import camelCase from 'lodash/camelCase';
import startCase from 'lodash/startCase';

import { Button } from '~/mappers/button/models';

import { NlToBrFunctionType, ToPascalCaseFunctionType } from './models';

export const toPascalCase: ToPascalCaseFunctionType = (str) =>
  startCase(camelCase(str)).replace(/ /g, '');

export const nlToBr: NlToBrFunctionType = (str) =>
  str?.replace(/\n/g, '<br />');

const camelCaseKey = (key: string) => {
  const toUpperCase = ['ui'];
  const parts = key.split('_');
  const camelCaseParts = parts.map((part, index) => {
    if (
      index === parts.length - 1 &&
      toUpperCase.includes(part.toLowerCase())
    ) {
      return part.toUpperCase();
    }

    return index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1);
  });

  return camelCaseParts.join('');
};

export const snakeToCamelWithSpecialCases = (
  inputObject: Record<string, any>
) => {
  // TODO - replace above camelCaseKey with version below after https://bitbucket.org/rbdigital/phx-husky/pull-requests/893 merge
  // const camelCaseKey = (str: string) =>
  // str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

  if (Array.isArray(inputObject)) {
    return inputObject.map((item) =>
      typeof item === 'object' && item !== null
        ? snakeToCamelWithSpecialCases(item)
        : item
    );
  }

  if (typeof inputObject === 'object' && inputObject !== null) {
    const camelCaseObj = {};
    Object.entries(inputObject).forEach(([key, value]) => {
      camelCaseObj[camelCaseKey(key)] =
        typeof value === 'object' && value !== null
          ? snakeToCamelWithSpecialCases(value)
          : value;
    });

    return camelCaseObj;
  }

  return inputObject;
};

const stringUtils = {
  toPascalCase,
  nlToBr,
  snakeToCamelWithSpecialCases,
};

export const validateTextLength = (button: Button) => {
  const MAX_LENGTH_WITH_ICON = 18;
  const MAX_LENGTH_WITHOUT_ICON = 22;

  if (
    (button.text.length > MAX_LENGTH_WITH_ICON &&
      button.iconPrefix.length > 0) ||
    button.iconSuffix.length > 0
  ) {
    return `${button.text.slice(0, MAX_LENGTH_WITH_ICON)}`;
  }
  if (button.text.length > MAX_LENGTH_WITHOUT_ICON) {
    return `${button.text.slice(0, MAX_LENGTH_WITHOUT_ICON)}`;
  }

  return button.text;
};

export default stringUtils;
